// Shared geo helpers for the Homes / Vehicles / Market filters.
// Groups state options by US Census region and orders everything alphabetically.

export const REGION_ORDER = ["Northeast", "South", "West", "Midwest", "Other"];

export const STATE_REGION = {
  WA: "West", OR: "West", CA: "West", NV: "West", AZ: "West", ID: "West", MT: "West",
  WY: "West", CO: "West", UT: "West", NM: "West", HI: "West", AK: "West",
  TX: "South", OK: "South", AR: "South", LA: "South", MS: "South", AL: "South",
  TN: "South", KY: "South", GA: "South", FL: "South", SC: "South", NC: "South",
  VA: "South", WV: "South", MD: "South", DC: "South", DE: "South",
  ME: "Northeast", NH: "Northeast", VT: "Northeast", MA: "Northeast", RI: "Northeast",
  CT: "Northeast", NY: "Northeast", NJ: "Northeast", PA: "Northeast",
  OH: "Midwest", IN: "Midwest", IL: "Midwest", MI: "Midwest", WI: "Midwest", MN: "Midwest",
  IA: "Midwest", MO: "Midwest", ND: "Midwest", SD: "Midwest", NE: "Midwest", KS: "Midwest",
};

// options: [{ value, count, region? }] → [{ region, options: [...] }] (regions & options A→Z)
export function groupStatesByRegion(options = []) {
  const byRegion = {};
  for (const o of options) {
    const region = o.region || STATE_REGION[o.value] || "Other";
    (byRegion[region] ||= []).push(o);
  }
  return REGION_ORDER
    .filter((r) => byRegion[r]?.length)
    .map((region) => ({
      region,
      options: byRegion[region].sort((a, b) => String(a.value).localeCompare(String(b.value))),
    }));
}
